import { DatePipe } from "@angular/common";
import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { EntityPagedResult, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_GESTOR_ENVIO, ROLE_AGENTE_CONSULTA } from "src/app/constantes/permissao.constants";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import { ExportService } from "../../export.service";
import { HabilitacaoAlternativa } from "src/app/model/habilitacao-alternativa.model";
import { AgenteFinanceiroService } from "src/app/shared/services/agente-financeiro.service";
import { HabilitacaoService } from "../../habilitacao.service";
import { MensagemService } from "src/app/features/mensagem.service";

@Component({
    selector: 'app-habilitacao-alternativa-pesquisa',
    templateUrl: './habilitacao-alternativa-pesquisa.component.html',
    standalone: false
})
export class HabilitacaoAlternativaPesquisaComponent implements OnInit {

  atributosPaginacaoComponenteListagem: EntityPagedResult<HabilitacaoAlternativa>;
  pesquisado: boolean = false;
  cnpjUsuario: string;
  pesquisaForm: UntypedFormGroup;
  opcoesPaginacao: number[];
  habilitacoes: HabilitacaoAlternativa[];
  podeCadastrarHabilitacao: boolean;
  naoPodeConsultarTodos: boolean = false;
  agentesFinanceiros: AgenteFinanceiro[] = [];
  situacoes: any;
  msgSemResultado: boolean = false;
  dataHoraResultado: string;
  idHabilitacaoExcluir: number;

  constructor(
    private datePipe: DatePipe,
    private formBuilder: UntypedFormBuilder,
    private bnLoadingService: BnLoadingService,
    private permissaoService: PermissaoService,
    private exportService: ExportService,
    private bnUsuarioService: BnUsuarioService,
    private el: ElementRef,
    private agenteFinanceiroService: AgenteFinanceiroService,
    private habilitacaoService: HabilitacaoService,
    private mensagemService: MensagemService,
    private bnModalService: BnModalMessageService,
  ) {
    this.pesquisaForm = this.formBuilder.group({
      situacao: null,
      dataInicioVigencia: null,
      dataFimVigencia: null,
      agenteFinanceiro: null,
      cnpjUsuario: null,
    });
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscar(false);
  }

  ngOnInit() {
    this.opcoesPaginacao = [10, 15, 20];

    this.situacoes = [
      {label: 'Ativo', value: 'Ativo'},
      {label: 'Vencido', value: 'Vencido'},
      {label: 'Suspenso', value: 'Suspenso'},
      {label: 'Inativo', value: 'Inativo'},
    ]

    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };

    this.agenteFinanceiroService.getAgentesFinanceiros()
        .subscribe((response => {
            this.agentesFinanceiros = response ? response.sort((a, b) => a?.sigla ? a.sigla.localeCompare(b.sigla) : 0) : null;
            this.setAgenteNoFormulario();
        }));

    this.permissaoService.getPermissoesUsuarioAutenticado()
      .subscribe((resp: any) => {
        this.podeCadastrarHabilitacao = resp && resp[ROLE_GESTOR_ENVIO];
        this.naoPodeConsultarTodos = resp && resp[ROLE_AGENTE_CONSULTA];
        if (resp && resp[ROLE_AGENTE_CONSULTA]) {
          this.bnUsuarioService.usuario$.subscribe(usuario => {
            if (usuario && usuario.cnpj) {
              this.cnpjUsuario = usuario.cnpj;
              this.setAgenteNoFormulario();
            }
          });
        }
      });
  }

  setAgenteNoFormulario() {
    if (this.cnpjUsuario) {
      const agente = this.agentesFinanceiros.find(a => a.cnpj === this.cnpjUsuario);
      if (agente) {
        this.pesquisaForm.get('agenteFinanceiro').setValue(agente.id);
        this.pesquisaForm.get('cnpjUsuario').setValue(this.cnpjUsuario);
      }
    }
  }

  limpar() {
    this.atributosPaginacaoComponenteListagem.page = 1;
    this.habilitacoes = [];
    this.msgSemResultado = false;
    if (!this.cnpjUsuario) {
        this.pesquisaForm.reset();
        this.cnpjUsuario = null;
    } else if (this.cnpjUsuario) {
        this.resetFormQuandoAFLogado();
    }
    setTimeout(() => {
        this.removeNgInvalidInput('dataInicioVigencia');
        this.removeNgInvalidInput('dataFimVigencia');
    }, 100);
  }

  resetFormQuandoAFLogado() {
    this.pesquisaForm = this.formBuilder.group({
        situacao: null,
        dataInicioVigencia: null,
        dataFimVigencia: null,
    });
  }

  removeNgInvalidInput(id: string) {
    const inputElement = this.el.nativeElement.querySelector(`#${id}`);
    inputElement.classList.remove('ng-invalid');
  }

  mudancaPagina(novaPagina: EntityPagedResult<HabilitacaoAlternativa>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(true);
  }

  buscar(paginado: boolean) {
    this.bnLoadingService.bloqueiaTela();
    const dadosPreenchidos = this.tratarInformacoesPreenchidas();
    dadosPreenchidos.pagina = paginado ? this.atributosPaginacaoComponenteListagem.page : 1;
    dadosPreenchidos.limite = this.atributosPaginacaoComponenteListagem.pageSize;

    this.habilitacaoService.getHabilitacoes(dadosPreenchidos).
      subscribe((response => {
        this.pesquisado = true;
        this.habilitacoes = response ? response.resultados : null;
        this.atributosPaginacaoComponenteListagem.count = response ?
          response.totalRegistrosSemPaginacao : 0;
        this.msgSemResultado = (this.atributosPaginacaoComponenteListagem.count === 0) || false;
        this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
      }));
    this.bnLoadingService.liberaTela();
  }

  tratarInformacoesPreenchidas() {
    let dadosPreenchidos: any = {};
    const form = this.pesquisaForm.value;
    if (form.dataInicioVigencia) {
      dadosPreenchidos.dataInicioVigencia = this.datePipe.transform(form.dataInicioVigencia, 'yyyyMMdd');
    }
    if (form.dataFimVigencia) {
      dadosPreenchidos.dataFimVigencia = this.datePipe.transform(form.dataFimVigencia, 'yyyyMMdd');
    }
    if (form.situacao) {
      dadosPreenchidos.situacao = form.situacao.value;
    }

    if (this.cnpjUsuario) {
      const agenteFinanceiro = this.agentesFinanceiros.find(agente => agente.cnpj === this.cnpjUsuario);
      dadosPreenchidos.agenteFinanceiro = agenteFinanceiro?.id;
      dadosPreenchidos.cnpjUsuario = this.cnpjUsuario;
    } else if (form.agenteFinanceiro) {
        dadosPreenchidos.agenteFinanceiro = form.agenteFinanceiro;
    }
    return dadosPreenchidos;
  }

  exportarHabilitacoes() {
    this.bnLoadingService.bloqueiaTela();
    const dadosPreenchidos = this.tratarInformacoesPreenchidas();
    this.habilitacaoService.getHabilitacoes(dadosPreenchidos).subscribe((resp) => {
      this.exportService.exportarHabilitacoesAlternativas(resp);
    });
  }

  async excluir(id: number) {
    this.bnLoadingService.bloqueiaTela();
    this.idHabilitacaoExcluir = id;
    
    try {
      await this.habilitacaoService.excluir(this.idHabilitacaoExcluir).toPromise();
      this.mensagemService.adicionarMensagemSucesso('Habilitação Alternativa excluída com sucesso.');
      this.dismissModal();
      this.removeRow();
    } catch (err) {
      console.log('erro ao excluir habilitação alternativa', err);
      this.mensagemService.adicionarMensagemErro('Erro ao excluir habilitação alternativa.');
    }
    this.bnLoadingService.liberaTela();
  }

  removeRow() {
    let indice: number = this.habilitacoes.findIndex(h => h.id === this.idHabilitacaoExcluir);
    
    if (indice !== -1) {
      this.habilitacoes.splice(indice, 1)
    }

    if (this.habilitacoes.length === 0) {
      this.msgSemResultado = true;
    }

    this.atributosPaginacaoComponenteListagem.count -= 1;
  }

  dismissModal() {
    this.bnModalService.dismiss();
  }

}
